import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from './contexts/ThemeContext'
import App from './App'
import './index.css'

// Register service worker for notification actions
if ('serviceWorker' in navigator) {
  // First, clear ALL existing service worker registrations to fix any scope issues
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    const currentOrigin = window.location.origin;
    console.log(`🧹 Clearing ${registrations.length} existing service worker registrations`);
    
    const unregisterPromises = registrations.map((registration) => {
      console.log('Unregistering service worker:', registration.scope);
      return registration.unregister();
    });
    
    // Wait for all unregistrations to complete, then register fresh
    Promise.all(unregisterPromises).then(() => {
      console.log('✅ All service workers unregistered, registering fresh...');
      
      // Small delay to ensure cleanup is complete
      setTimeout(() => {
        navigator.serviceWorker.register('/sw.js', {
          scope: '/',
          updateViaCache: 'none' // Always check for updates
        })
          .then((registration) => {
            console.log('🎉 Service Worker registered successfully:', registration);
            console.log('Service Worker scope:', registration.scope);
            console.log('Current origin:', currentOrigin);
            
            // Ensure the service worker activates immediately
            registration.addEventListener('updatefound', () => {
              const newWorker = registration.installing;
              if (newWorker) {
                newWorker.addEventListener('statechange', () => {
                  if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    console.log('🔄 New service worker installed, updating...');
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                  }
                });
              }
            });
          })
          .catch((error) => {
            console.error('❌ Service Worker registration failed:', error);
          });
      }, 100);
    });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
)